import { render } from "./AndroidBanner.vue?vue&type=template&id=16910796&scoped=true"
import script from "./AndroidBanner.vue?vue&type=script&lang=js"
export * from "./AndroidBanner.vue?vue&type=script&lang=js"

import "./AndroidBanner.vue?vue&type=style&index=0&id=16910796&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16910796"]])

export default __exports__